module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.7.2 发布日志")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/alert.html"
    }
  }, [_vm._v("Alert")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持作为模块直接调用 (import { AlertModule } from 'vux') #2173")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/calendar.html"
    }
  }, [_vm._v("Calendar")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持禁用选择属性 prop:readonly #2178")]), _vm._v(" "), _c('li', [_vm._v("[fix] 修复 on-change 事件重复触发的问题")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/datetime.html"
    }
  }, [_vm._v("Datetime")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] 当指定结束日期但未指定开始日期时使用默认年第一天作为开始日期 #2158")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/inline-calendar.html"
    }
  }, [_vm._v("InlineCalendar")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 修复多选情况下重置值时没有正确渲染的问题 #2160")]), _vm._v(" "), _c('li', [_vm._v("[fix] 修复部分属性没有继承 inline-calendar 的问题 #2105")]), _vm._v(" "), _c('li', [_vm._v("[fix] 修复禁用周末日期仍能点击的问题 #2178")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/selector.html"
    }
  }, [_vm._v("Selector")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持 value-map 属性用以自动转换 API 数据 #2139")]), _vm._v(" "), _c('li', [_vm._v("[feature] 支持 getFullValue 方法获取当中选中值的原始数据")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/tab.html"
    }
  }, [_vm._v("Tab")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持阻止自动切换 #2176")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4b1e93f1", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-4b1e93f1"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/v2.7.2-261.vue
// module id = 2217
// module chunks = 248